/**
 * The required reason on the commissioner review panels (#102). The kit has no
 * multiline field, so this follows the house rules field: a label above, a
 * textarea at least one touch target tall, and the kit's focus ring.
 */
import { cn, FOCUS_RING } from "@sportsmet/ui";
import { type ReactNode, useId } from "react";

export const REVIEW_REASON_MAX_LENGTH = 3000;

export function ReviewReasonField(props: {
  label: string;
  value: string;
  disabled: boolean;
  onChange: (next: string) => void;
}): ReactNode {
  const id = useId();
  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={id} className="text-caption text-ink">
        {props.label}
      </label>
      <textarea
        id={id}
        rows={3}
        required
        maxLength={REVIEW_REASON_MAX_LENGTH}
        value={props.value}
        disabled={props.disabled}
        className={cn(
          "min-h-touch-target w-full rounded-sm border border-line bg-surface px-3 py-3 text-input text-ink",
          FOCUS_RING,
        )}
        onChange={(event) => {
          props.onChange(event.target.value);
        }}
      />
    </div>
  );
}
